import { HelpOutline } from '@mui/icons-material';
import { IconButton, Stack, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

/** The definition remains available to mouse, keyboard and touch users. */
export function PerformanceHelp({ label, help }: { label: string; help: string }) {
  const { t } = useTranslation();
  return (
    <Tooltip title={help} enterTouchDelay={0} leaveTouchDelay={5000}>
      <IconButton size="small" aria-label={t('workflowPerformance.helpFor', { label })}>
        <HelpOutline fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}

export function MetricLabel({ label, help }: { label: string; help: string }) {
  return (
    <Stack component="span" direction="row" alignItems="center" justifyContent="center" spacing={0.5}>
      <span>{label}</span>
      <PerformanceHelp label={label} help={help} />
    </Stack>
  );
}
